import React, { useState, useEffect } from "react";
import { Typography } from "@mui/material";
import { Trans } from "react-i18next";
import {
  helpscoutURL,
  privacyHelpscoutId,
  termsHelpscoutId,
} from "../../Variables";

const ConsentMessage = ({
  knownCountry,
  newCountry,
  gdprCountry,
  gdprConsentVisibility,
  email,
  formState,
  newCountryCode,
}) => {
  const [consentMessage, setConsentMessage] = useState(0);
  // email from US existing in the DB: testusernogdpr@asdf.com - hide message
  // email from PL existing in the DB with accepted GDPR: testuserwithgdpr@asdf.com - hide message
  // email from PL existing in the DB with not accepted GDPR: testuserwithgdprbutno@asdf.com - we process your information...
  // new user, country with GDPR: we process your information...
  // new user, country without GDPR: by signing you accept...

  // 1 - We process your information...
  // 2 - By signing you accept...

  const showConsentMessageExistingUser = () => {
    if (!knownCountry || gdprCountry === -1) {
      return 0;
    }
    return gdprConsentVisibility ? 1 : 0;
  };

  const showConsentMessageNewUser = () => {
    if (formState !== 4 && formState !== 6) {
      return 0;
    }
    if (!newCountryCode) {
      return 0;
    }
    return newCountry === -1 ? 2 : 1;
  };

  useEffect(() => {
    const newMessage = !newCountryCode
      ? 0
      : formState === 4 || formState === 6
      ? showConsentMessageNewUser()
      : showConsentMessageExistingUser();

    setConsentMessage(newMessage);
  }, [
    knownCountry,
    gdprCountry,
    gdprConsentVisibility,
    newCountry,
    email,
    formState,
    newCountryCode,
  ]);
  return (
    <div>
      {consentMessage === 1 && (
        <Typography
          sx={{ fontSize: "12px" }}
          variant="caption"
          display="block"
          marginTop="10px"
          textAlign="left"
          color="#363135"
          lineHeight="1.5"
        >
          <Trans i18nKey={"petition_form.data_processing"}>
            X
            <a
              href={`${helpscoutURL}/article/${privacyHelpscoutId()}-privacy`}
              target="_blank"
              rel="noreferrer"
            >
              Y
            </a>
            Z
            <a
              href={`${helpscoutURL}/article/${termsHelpscoutId()}-terms`}
              target="_blank"
              rel="noreferrer"
            >
              T
            </a>
            U
          </Trans>
        </Typography>
      )}
      {consentMessage === 2 && (
        <Typography
          sx={{ fontSize: "12px", textAlign: "left" }}
          variant="caption"
          display="block"
          marginTop="10px"
        >
          <Trans i18nKey={"petition_form.terms_of_use_acceptance"}>
            X
            <a
              href={`${helpscoutURL}/article/${termsHelpscoutId()}-terms`}
              target="_blank"
              rel="noreferrer"
            >
              Y
            </a>
            Z
            <a
              href={`${helpscoutURL}/article/${privacyHelpscoutId()}-privacy`}
              target="_blank"
              rel="noreferrer"
            >
              T
            </a>
            U
          </Trans>
        </Typography>
      )}
    </div>
  );
};

export default ConsentMessage;
